import t_09_2216 from './KZ.T.09.2216.svg'
import t_09_2216_b from './KZ.T.09.2216 black.svg'

export default [
  t_09_2216,
  t_09_2216_b,
]
